import React from 'react'

import { Modal } from '../../../../components/Modal/Modal'
import { ReactComponent as ZocksIcon } from '../../../../assets/ZocksLogo.svg'
import { ReactComponent as ZapierLogo } from '../../../../assets/zapier_logo.svg'

import styles from './ZapierActionModal.module.scss'

export interface ZapierActionModalProps {
  open: boolean
  onClose: () => void
}

export const ZapierActionModal: React.FC<ZapierActionModalProps> = ({ open, onClose }) => {
  const body = (
    <div className='d-flex flex-column gap-3 mb-4'>
      <div className='d-flex align-items-center gap-3'>
        <div className={`rounded-circle bg-dark d-flex align-items-center justify-content-center ${styles.sourceIcon}`}>
          <ZocksIcon />
        </div>
        <i className='bi bi-arrow-right zocks-text-gray-500' />
        <ZapierLogo className={styles.zapierLogo} aria-label='Zapier' />
      </div>
      <div className='paragraph-medium'>Automate with Zapier is coming soon.</div>
      <div className='paragraph-medium'>We&apos;re building this now. We&apos;ll notify you when it&apos;s ready.</div>
    </div>
  )

  return (
    <Modal
      show={open}
      onHide={onClose}
      header={<h4>Automate with Zapier</h4>}
      body={body}
      showFooterActions={true}
      hideSecondaryAction={true}
      footerPrimaryActionTitle='Close'
      onFooterPrimaryAction={onClose}
      footerClassName='px-4 pb-4 pt-0'
      centered={true}
    />
  )
}
